<script setup lang="ts">
interface Site {
  comps?: Array<{
    id: string;
    uri: string;
    title: string;
    win: string;
    compLive: string;
  }>;
  [key: string]: any; // Add this to allow other properties if needed
}

const site = useSite() as Ref<Site>;
const page = usePage().value;
const { gsap } = useGSAP();
const scrollTo = () => {
  if (gsap.value) {
    gsap.value.to(window, {
      duration: 1,
      scrollTo: {
        y: "#trekNavEurope",
        offsetY: 101, // This can work if you've extended ScrollToPlugin, or manually calculate y
      },
      ease: "power2.inOut",
    });
  }
};

const comps = computed(() => site.value?.comps ?? []);
const activeComps = computed(() =>
  comps.value.filter((comp) => comp.compLive === "true"),
);
const hasActiveComp = computed(() => activeComps.value.length > 0);
</script>
<template>
  <div class="cta">
    <div
      v-if="hasActiveComp && page?.template !== 'competition'"
      class="comp-badge"
    >
      <div v-for="comp in activeComps" :key="comp.id">
        <NuxtLink :to="`/${comp.uri}`">
          <div class="badge">
            <h3>{{ comp.title }}</h3>
            <p class="badge-win">{{ comp.win }}</p>
            <p class="badge-enter">Click here to enter</p>
          </div>
        </NuxtLink>
      </div>
    </div>
    <div v-else>
      <AppSVGBrandIcons />
      <div
        v-if="page?.template === 'home'"
        class="hero-btn btn from-left"
        @click.prevent="scrollTo"
      >
        View Our Treks
      </div>
      <NuxtLink
        v-if="
          page?.title !== 'Contact Us' &&
          page?.template !== 'home' &&
          page?.template !== 'trek-landing-page'
        "
        to="/get-in-touch"
        class="hero-btn btn from-left"
      >
        Enquire Now
      </NuxtLink>
      <NuxtLink
        v-if="page?.title === 'Contact Us'"
        to="/essential-info/booking-your-trek"
        class="hero-btn btn from-left"
      >
        Ready to book?
      </NuxtLink>
    </div>
  </div>
</template>
